import { createContext } from "react";

const GridContext = createContext({});

export default GridContext;
